import { Box } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import IntegrityScores from ".";
import type { CollapsibleFormSectionProps } from "../../types";

function IntegrityScoresContainer({ open }: CollapsibleFormSectionProps) {
  return (
    <Box data-testid="writeable-integrity-scores-container">
      <SectionCollapsible open={open} label="Integrity Scores">
        <IntegrityScores />
      </SectionCollapsible>
    </Box>
  );
}

export default IntegrityScoresContainer;
